import axios from 'axios';

const instance = axios.create({
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

instance.interceptors.response.use((response) => response, (err) => Promise.reject(err));

export default {
  updateAreas(data) {
    return instance.post('/api/updateareas', data);
  },
  updateLines(data) {
    return instance.post('/api/updatelines', data);
  },
  getAreas(data) {
    return instance.post('/api/getareas', data);
  },
  getWorkers(data) {
    return instance.post('/api/getworkers', data);
  },
  getDashboard(data) {
    return instance.post('/api/getdashboard', data);
  },
  workerUpdate(data) {
    return instance.post('/api/workerupdate', data);
  },
  getUnbook(data) {
    return instance.post('/api/getunbook', data);
  },
  unbookCreate(data) {
    return instance.post('/api/unbookcreate', data);
  },
  createEvent(data) {
    return instance.post('/api/createevent', data);
  },
  updateEvent(data) {
    return instance.post('/api/updateevent', data);
  },
  removeEvent(data) {
    return instance.post('/api/removeevent', data);
  },
  getEvents(data) {
    return instance.post('/api/getevents', data);
  },
  getGps(data) {
    return instance.post('/api/getgps', data);
  },
  getPendingSupp(data) {
    return instance.post('/api/getpendingsupp', data);
  },
  getPendingImg(data) {
    return instance.post('/api/getpendingimg', data);
  },
  batchApproveSupp(data) {
    return instance.post('/api/batchapprovesupp', data);
  },
  getAssignedTasks(data) {
    return instance.post('/api/getassignedtasks', data);
  },
};
